import styles from "../index.module.scss";
import { DestinationDescriptor } from "views/page-content/platforms/platform/simulcast/types";
import { PlatformIcon } from "components/icons/PlatformIcon";

export const DestinationLogo = ({
    destination
}: {
    destination: DestinationDescriptor;
}) => {
    return (
        <div
            className={`${styles["destination-logo-wrapper"]} ${
                destination?.logoUrl ? styles["has-logo"] : ""
            }`}
        >
            {destination?.logoUrl && (
                <img
                    src={destination?.logoUrl}
                    alt={`${destination.name} logo`}
                />
            )}
            <PlatformIcon platformId={destination.platform} useNewIcon={true} />
        </div>
    );
};
